import React from 'react';
import PropTypes from 'prop-types';

const Label = props => (
  <div className={'content-label' + (props.className ? ' ' + props.className : '')}>
    <span className="flex">
      {props.label}{' '}
      {props.tooltip && (
        <section className={`help-component title-com-fatigue`}>
          <section className="box-help">
            <i className="fas fa-question-circle" />
            <section className={`box plus`}>{props.tooltip}</section>
          </section>
        </section>
      )}
    </span>
  </div>
);

export default Label;



// WEBPACK FOOTER //
// ./source/client/components/common/label.jsx